// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zAhZeAeBIQVkIU8_ea3n{display:flex;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px;white-space:pre-wrap}.zAhZeAeBIQVkIU8_ea3n .Pucp06ooIiEotqJesLEk{font-size:10px;color:#8496b9}.zAhZeAeBIQVkIU8_ea3n .q5IKx4hy8UoNI2Utvhoh{object-fit:contain;width:100%;max-height:400px}.zAhZeAeBIQVkIU8_ea3n .Zk0ugURgZbnpi0Ih6P8z{display:flex;justify-content:center;align-items:center;height:100%;padding:1rem;font-size:12px !important}.zAhZeAeBIQVkIU8_ea3n .Zk0ugURgZbnpi0Ih6P8z .rrC_i5cNEibMxL43zpSs{margin-bottom:1.5rem;line-height:1.6}.zAhZeAeBIQVkIU8_ea3n .Zk0ugURgZbnpi0Ih6P8z .TrJ_qktOM_iup2g_8XbR{list-style-type:disc;padding-left:2rem;margin:0}.zAhZeAeBIQVkIU8_ea3n .Zk0ugURgZbnpi0Ih6P8z .TrJ_qktOM_iup2g_8XbR li{margin-bottom:.75rem;line-height:1.4}.zAhZeAeBIQVkIU8_ea3n .Zk0ugURgZbnpi0Ih6P8z .BcniEYJiqGPaO3P0zQMh{line-height:1.6;white-space:pre-wrap}.zAhZeAeBIQVkIU8_ea3n .fAyxnO1KLLFpX2unrHgs{width:45%;font-size:12px;height:100%;margin-bottom:2rem}.zAhZeAeBIQVkIU8_ea3n .d7CJ4KabdsAi1LoZ157A{font-size:1.5rem;font-weight:bold;margin-top:0;margin-bottom:1rem;color:#6e32f0}.zAhZeAeBIQVkIU8_ea3n .E_byhML3nMnLjukwlcf9{font-size:1rem;line-height:1.5}.zAhZeAeBIQVkIU8_ea3n .SAulGwYkiyxvzepqwZTT{height:100%;background-color:#e5e5e5;margin:2rem 1rem;width:2px}.zAhZeAeBIQVkIU8_ea3n p{font-size:12px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slide": `zAhZeAeBIQVkIU8_ea3n`,
	"imgDescription": `Pucp06ooIiEotqJesLEk`,
	"image": `q5IKx4hy8UoNI2Utvhoh`,
	"carouselItem": `Zk0ugURgZbnpi0Ih6P8z`,
	"topText": `rrC_i5cNEibMxL43zpSs`,
	"bulletPoints": `TrJ_qktOM_iup2g_8XbR`,
	"bottomText": `BcniEYJiqGPaO3P0zQMh`,
	"content": `fAyxnO1KLLFpX2unrHgs`,
	"title": `d7CJ4KabdsAi1LoZ157A`,
	"description": `E_byhML3nMnLjukwlcf9`,
	"divider": `SAulGwYkiyxvzepqwZTT`
};
export default ___CSS_LOADER_EXPORT___;
